// @ts-nocheck



import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  ExpertiseServiceGpmList,
  ExpertiseServiceGpmMonthList,
  InspectionsGibddList,
  InspectionsGibddMonthList,
  InspectionsGtnList,
  InspectionsGtnMonthList,
  LicensePlateChangeList,
  LicensePlateChangeMonthList,
  MaintenanceList,
  MaintenanceMonthList,
  MaintenanceCompare,
  MeasuringDeviceCertificationsList,
  MeasuringDeviceCertificationsMonthList,
  PassList,
  PassMonthList,
  PlatonList,
  PlatonMonthList,
  VehicleMonitoringList,
  VehicleMonitoringMonthList,
  WashingList,
  WashingMonthList } from
'./components';
import { RouteComponent } from '../../../lib/routerAdapter';

export default () =>
<>
    <Routes>
      <Route path="expertise-service-gpm" element={<RouteComponent component={ExpertiseServiceGpmList} />} />
      <Route path="expertise-service-gpm/month" element={<RouteComponent component={ExpertiseServiceGpmMonthList} />} />

      <Route path="inspections-gibdd" element={<RouteComponent component={InspectionsGibddList} />} />
      <Route path="inspections-gibdd/month" element={<RouteComponent component={InspectionsGibddMonthList} />} />

      <Route path="inspections-gtn" element={<RouteComponent component={InspectionsGtnList} />} />
      <Route path="inspections-gtn/month" element={<RouteComponent component={InspectionsGtnMonthList} />} />

      <Route path="license-plate-change" element={<RouteComponent component={LicensePlateChangeList} />} />
      <Route path="license-plate-change/month" element={<RouteComponent component={LicensePlateChangeMonthList} />} />

      <Route index element={<RouteComponent component={MaintenanceList} />} />
      <Route path="maintenance/month" element={<RouteComponent component={MaintenanceMonthList} />} />
      <Route path="maintenance/compare" element={<RouteComponent component={MaintenanceCompare} />} />

      <Route path="measuring-device-certifications" element={<RouteComponent component={MeasuringDeviceCertificationsList} />} />
      <Route path="measuring-device-certifications/month" element={<RouteComponent component={MeasuringDeviceCertificationsMonthList} />} />

      <Route path="pass" element={<RouteComponent component={PassList} />} />
      <Route path="pass/month" element={<RouteComponent component={PassMonthList} />} />

      <Route path="platon" element={<RouteComponent component={PlatonList} />} />
      <Route path="platon/month" element={<RouteComponent component={PlatonMonthList} />} />

      <Route path="vehicle-monitoring" element={<RouteComponent component={VehicleMonitoringList} />} />
      <Route path="vehicle-monitoring/month" element={<RouteComponent component={VehicleMonitoringMonthList} />} />

      <Route path="washing" element={<RouteComponent component={WashingList} />} />
      <Route path="washing/month" element={<RouteComponent component={WashingMonthList} />} />
    </Routes>
  </>;
